import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

interface InlineLoaderProps {
  label?: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
  /** Renders just the spinner icon without a wrapper (for buttons, cells) */
  inline?: boolean
}

const sizeMap = {
  sm: 'h-3.5 w-3.5',
  md: 'h-5 w-5',
  lg: 'h-8 w-8',
} as const

/**
 * Unified loading spinner. Single source of truth for all loading indicators.
 *
 * - Block mode (default): centered container, primary-colored spinner
 * - `inline` mode: bare icon that inherits parent color (for buttons)
 */
export function InlineLoader({
  label,
  size = 'md',
  className,
  inline = false,
}: InlineLoaderProps) {
  if (inline) {
    return (
      <Loader2
        className={cn(sizeMap[size], 'animate-spin', className)}
        aria-label={label ?? 'Chargement'}
      />
    )
  }

  return (
    <div className={cn('flex items-center justify-center gap-2', className)}>
      <Loader2
        className={cn(sizeMap[size], 'animate-spin text-primary')}
        aria-label={label ?? 'Chargement'}
      />
      {label && <span className='text-sm text-muted-foreground'>{label}</span>}
    </div>
  )
}
